import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';

import { useFlow } from '../../../../providers';
import { GeneratedPaymentMethod } from '../../../../types/generated';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { CardButton } from '../CardButton';

interface Props {
  selectedPaymentMethodId: string | null;
  setSelectedPaymentMethodId: (paymentMethodId: string) => void;
  canSave: boolean;
  paymentMethods: GeneratedPaymentMethod[];
  onSave: (paymentMethodId: string | null) => Promise<void>;
}

export const PaymentMethodSelector = ({
  canSave,
  onSave,
  paymentMethods,
  selectedPaymentMethodId,
  setSelectedPaymentMethodId,
}: Props) => {
  const { t } = useTranslation(['product', 'countries']);
  const { goToStep } = useFlow();

  const [emitter] = useAnalyticsEmitter();

  return (
    <div className="flex flex-col space-y-6">
      <CheckboxWrapper>
        {paymentMethods.map((payment, index) => {
          if (!payment.card)
            // eslint-disable-next-line react/no-array-index-key
            return <span key={`payment-${index}`}>Unknown payment method</span>;

          return (
            <CheckboxCard
              key={`payment-${payment.card.expireMonth}-${payment.card.last4}`}
              checked={
                selectedPaymentMethodId === payment.providerPaymentMethodId
              }
              id={`payment-${index}`}
              label={`∙∙∙∙ ∙∙∙∙ ∙∙∙∙ ${payment.card.last4}`}
              name="paymentMethod"
              onChange={() =>
                setSelectedPaymentMethodId(payment.providerPaymentMethodId)
              }
              type="radio"
              value={`payment-${index}`}
            />
          );
        })}

        <CardButton
          icon="chevron"
          onClick={() => {
            if (paymentMethods.length === 0) {
              emitter('add new', 'clicked');
            }
            goToStep('add_payment_method');
          }}
        >
          {t('drawers.payment.addNewButton')}
        </CardButton>
      </CheckboxWrapper>

      <Button
        disabled={!canSave}
        fullWidth
        label={t('drawers.payment.saveButton')}
        onClick={() => {
          emitter('existing', 'selected');
          onSave(selectedPaymentMethodId);
        }}
        variant="primary"
      />
    </div>
  );
};
